import {
  CounsellorConnect,
  CounsellorHero,
  CounsellorThumbSection,
} from "@modules/study/counsellor";
import API from "@unisearch/helpers/api";

import PartnerGrid from "@modules/study/common/sections/partner_grid";
import { LayoutMain } from "@unisearch/theme/layout";

const Counsellor = ({ counsellor }) => {
  return (
    <LayoutMain
      title="Counsellor"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/counsellors`}
    >
      <CounsellorHero />
      {counsellor?.length > 0 && (
        <CounsellorThumbSection counsellor={counsellor} />
      )}
      <CounsellorConnect />
      <PartnerGrid />
    </LayoutMain>
  );
};

export default Counsellor;

export async function getServerSideProps() {
  let props = {
    counsellor: "",
  };

  try {
    let counsellorList = await API.get(`/public/user-counsellor`);
    if (counsellorList.data) {
      props.counsellor = counsellorList.data;
    }

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
